module.exports = __webpack_public_path__ + "static/media/correct-answer-tone.7830f561.wav";